function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26.5425 38.34L26.0213 39.1934L26.5425 38.34C25.9025 37.9491 25.0975 37.9491 24.4575 38.34L24.9787 39.1934L24.4575 38.34L10.8665 46.6413L14.5617 31.1502C14.7357 30.4207 14.4869 29.6552 13.9174 29.1673L1.82246 18.8067L17.6972 17.534C18.4448 17.4741 19.096 17.001 19.384 16.3085L25.5 1.60396L31.616 16.3085C31.904 17.001 32.5552 17.4741 33.3028 17.534L49.1775 18.8067L37.0826 29.1673C36.5131 29.6552 36.2643 30.4207 36.4383 31.1502L40.1335 46.6413L26.5425 38.34Z",
  fill: "#F3F4F5",
  stroke: "#E8E9EB",
  strokeWidth: 2
});

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 48,
    viewBox: "0 0 51 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.cc137024.svg";
export { ForwardRef as ReactComponent };